import createFeatureToggle from './createFeatureToggle';
import mapCheckers from './mapCheckers';

export default (features, checkers) => {
  return createFeatureToggle(mapCheckers(features, checkers));
};
